import { post, get } from '@/utils/request'

// 获取服务器时间戳
export function serverTime () {
  return post('/miniapps/ponhu/serverTime')
}
// 快速登录
export function quicklyLogin (data) {
  return post('/miniapps/userLogin/quickLogin', data)
}
// 发送短信验证码
export function sendVCode (data) {
  return get('/miniapps/verificationCode/loginVerificationCode', data)
}
// 第三方登录
export function JointLogin (data) {
  return post('/miniapps/User/callback', data)
}
